import React from "react";
import { Commend3Model } from "../Types";
import { hasStrategy, resolveGenerationBadge } from "../Commend3Helper";
import { NOT_CONFIGURED_LABEL, STALE_GENERATION_HINT } from "../Commend3Constants";

type GenerationStatusBadgeProps = {
  id: string;
  model: Commend3Model;
};

const CHIP_STYLES: Record<string, React.CSSProperties> = {
  notConfigured: { background: "#F4F5F9", color: "#9C9C9C" },
  generating: { background: "#EAF0FF", color: "#0B5FCB" },
  notGenerated: { background: "#F4F5F9", color: "#59596E" },
  generated: { background: "#FEF6E0", color: "#B45309" },
  stale: { background: "#FEE9EC", color: "#D60027" },
};

const CHIP_BASE =
  "tw-inline-block tw-whitespace-nowrap tw-rounded tw-px-2.5 tw-py-[3px] tw-text-[12px] tw-font-medium";

const GenerationStatusBadge = ({ id, model }: GenerationStatusBadgeProps) => {
  if (!hasStrategy(model)) {
    return (
      <span id={id} className={CHIP_BASE} style={CHIP_STYLES.notConfigured}>
        {NOT_CONFIGURED_LABEL}
      </span>
    );
  }

  const badge = resolveGenerationBadge(model);
  if (!badge) return <span id={id} />;

  const stale = Boolean(model?.promotion_status?.regenerated) && badge.variant === "generated";
  const tone = stale ? CHIP_STYLES.stale : CHIP_STYLES[badge.variant] ?? CHIP_STYLES.notGenerated;

  return (
    <div id={id}>
      <span
        className={CHIP_BASE}
        style={tone}
        title={stale ? STALE_GENERATION_HINT : undefined}
      >
        {stale ? `⚠ ${badge.label}` : badge.label}
      </span>
      {badge.timestamp ? (
        <div className="tw-mt-1 tw-text-[11.5px] tw-text-[#59596E]">{badge.timestamp}</div>
      ) : null}
    </div>
  );
};

export default GenerationStatusBadge;
